import React, {useEffect, useState} from "react";
import {Row, Col, Transfer, Button, Popover} from "antd";
import isEmpty from "lodash/isEmpty";
import UserInfoCard from "../UserInfoCard/UserInfoCard";
import UserSelect from "../UserSelect/UserSelect";
import compareStringsWithPoints from "../../../../lib/utils/compareStringWithPoints";

const styles = {
  transfer: {
    height: "60vh",
  },
  transferList: {
    width: "100%",
    height: "60vh",
  },
};

export default function AdministrationRoles(props) {
  const {
    users,
    permissions,
    permissionsLoading,
    selectedUser,
    handleSelectUser,
    handleAssignPermissionsToUser,
    selectable = true,
    user,
  } = props;
  const [rolesPermissions, setRolesPermissions] = useState([]);

  useEffect(() => {
    if (user) {
      setRolesPermissions(user.includedRoles.map((role) => role.includedPermissions).flat());
    }
  }, [user]);

  const [transferData, setTransferData] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);
  const [isDisabledButton, setIsDisabledButton] = useState(true);

  useEffect(() => {
    setTransferData(
      permissions.map((permission) => ({
        key: permission.id,
        id: permission.id,
        alias: permission.alias,
        dsc: permission.dsc,
        disabled: rolesPermissions.some((item) => item.id === permission.id),
      }))
    );
  }, [permissions, permissionsLoading, rolesPermissions]);

  useEffect(() => {
    if (typeof selectedUser !== "undefined") {
      setTargetKeys(
        [
          ...selectedUser.includedPermissions.map((item) => item),
          ...rolesPermissions.map((item) => item),
        ]
          .sort((a, b) => compareStringsWithPoints(a.alias, b.alias))
          .map((item) => item.id)
      );
    }
  }, [rolesPermissions, selectedUser]);

  const handleChange = (nextTargetKeys) => {
    setTargetKeys([...nextTargetKeys]);
    setIsDisabledButton(false);
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={8}>
          {selectable && (
            <UserSelect users={users} handleChangeUser={handleSelectUser} selectable={selectable}/>
          )}
          {!isEmpty(selectedUser) && <UserInfoCard user={selectedUser}/>}
        </Col>
        <Col flex="1">
          <Transfer
            dataSource={transferData}
            targetKeys={targetKeys}
            onChange={handleChange}
            titles={["Доступные привилегии", "Назначенные привилегии"]}
            render={(item) => <Popover content={item.dsc}>{item.alias}</Popover>}
            showSearch
            filterOption={(inputValue, item) =>
              item?.dsc &&(item.alias.toLowerCase().includes(inputValue.toLowerCase()) ||
                item.dsc.toLowerCase().includes(inputValue.toLowerCase()))
            }
            style={styles.transfer}
            listStyle={styles.transferList}
            disabled={isEmpty(selectedUser)}
          />
        </Col>
      </Row>
      <Row className="row_buttons" justify="end">
        <Button
          type="primary"
          onClick={() => {
            handleAssignPermissionsToUser(
              targetKeys.filter(
                (item) => !rolesPermissions.some((permission) => permission.id === item)
              )
            );
            setIsDisabledButton(true);
          }}
          htmlType="button"
          disabled={isDisabledButton}
        >
          Применить
        </Button>
      </Row>
    </>
  );
}
